<template>
    <div
        id="playlist"
        class="d-flex flex-column border-2 border-start border-primary overflow-scroll p-4"
    >
        <div
            v-for="(topic, index) in topics" :key="index"
            class="d-flex flex-column p-3 cursor-pointer align-items-center"
            @click="changeVideo(index)"
        >
            <div class="d-inline-block position-relative w-50">
                <img
                    class="img-thumbnail w-100 mb-1"
                    :src="topic.video.thumbnail"
                    :alt="topic.description"
                />
                <div class="position-absolute d-flex align-items-center justify-content-center top-0 start-0 bottom-0 end-0">
                    <div class="text-white rounded-3 px-4 py-1 bg-dark bg-opacity-50 border-2 border">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                            <path fill-rule="evenodd" d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z" clip-rule="evenodd"></path>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="ps-3 text-primary">
                <h5 class="fw-bold" v-text="topic.title"></h5>
                <p class="fw-medium text-dark" v-text="topic.description"></p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'playlist',
    props: {
        topics: {
            type: Array,
            default: () => {
                return []
            }
        },
        onboarding: false,
    },
    methods: {
        changeVideo(index) {
            this.$emit('selected', index)
        }
    },
}
</script>
